import axios from 'axios';
import store from '../store';
import { UUID_KEY, ACCESS_TOKEN_KEY } from "@/constants/localStorageKeys";

export default {
  init() {
    const Axios = axios.create({
      xsrfHeaderName: 'X-CSRF-Token',
      withCredentials: true,
      headers: {
        'X-SpotgigToken': localStorage.getItem(ACCESS_TOKEN_KEY),
        'uuid': localStorage.getItem(UUID_KEY)
      },
      timeout: 25000
    });
    Axios.defaults.headers.post['Content-Type'] = 'application/json';
    Axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
    Axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    Axios.interceptors.request.use((config) => {
      return config;
    }, (error) => {
      return Promise.reject(error);
    });
    Axios.interceptors.response.use((response) => {
      return response
    }, (error) => {
      if (error.response == null) {
        return Promise.reject({
          code: null,
          messages: [`<span class="u-color-error">通信に失敗しました。</span><br>インターネットの接続を確認してください。`],
        });
      } else if (error.response.status === 500) {
        return Promise.reject({
          code: error.response.status,
          messages: [`<span class="u-color-error">通信リクエスト中にサーバー側でエラーが発生しました。</span><br>時間を置いてからページを更新して下さい。<br>もししばらくたっても改善されない場合は、お手数ですが、運営まで問い合わせ下さい。`],
          data: error.response.data,
          headers: error.response.headers,
        });
      } else if (error.response.status === 503) {
        const messages = error.response.data.errors.map((error) => error.message);

        return Promise.reject({
          code: error.response.status,
          messages: messages,
          data: error.response.data,
          headers: error.response.headers,
        });
      } else {
        return Promise.reject({
          code: error.response.status,
          messages: [error.response.data.errors[0].message],
          data: error.response.data,
          headers: error.response.headers,
        });
      }
    });

    this.http = Axios;
  },

  request(method, url, params) {
    this.init();
    let promise = null;

    switch (method) {
      case 'get':
        promise = this.http.get(url, { params: params });
        break;
      case 'post':
        promise = this.http.post(url, params);
        break;
      case 'patch':
        promise = this.http.patch(url, params);
        break;
      case 'put':
        promise = this.http.put(url, params);
        break;
      case 'delete':
        promise = this.http.delete(url, params);
        break;
      default:
        throw new Error(`Can not use the action: ${method}.\nThis method has only allows actions to [get, post, patch, delete].`);
    }

    return promise;
  },

  get(url, params, callback) {
    return this.request('get', url, params).then((response) => {
      return callback(response);
    });
  },

  post(url, params, callback) {
    return this.request('post', url, params).then((response) => {
      return callback(response);
    });
  },

  patch(url, params, callback) {
    return this.request('patch', url, params).then((response) => {
      return callback(response);
    });
  },

  put(url, params, callback) {
    return this.request('put', url, params).then((response) => {
      return callback(response);
    });
  },

  delete(url, params, callback) {
    return this.request('delete', url, params).then((response) => {
      return callback(response);
    });
  }
}
